import React from 'react';
import Logo from "../../assets/image/luckcharmsweep.png";

const AboutUs = () => {
    return (
        <div className="flex flex-col md:flex-row items-center bg-[#290A47] p-8 rounded-lg text-white container mx-auto border-[3px] border-[#EC29FC]">
            <img src={Logo} alt="logo" className='w-[200px] md:w-[350px] mb-4 md:mb-0' />

            <div className="md:ml-8 text-center md:text-left">
                <h1 className="text-2xl md:text-3xl font-bold">
                    Lucky Charm Sweep - The Best Online Sweepstakes Platform in Los Angeles
                </h1>
                <p className="mt-4 text-base md:text-lg text-[#CACACA]">
                    BitPlay offers you the best slot games that are guaranteed to give you a memorable experience. We give you the latest and greatest online slots right to your doorstep to take advantage of the exceptional gaming experience whenever and wherever you want.
                </p>
            </div>
        </div>
    );
};

export default AboutUs;
